// extracted by mini-css-extract-plugin
export default {"notification-toast":"a6284c"};